import React from 'react'
import { MenuItem, TextField } from '@mui/material'

/**
 * Insurance slicer — restricts the Market comparison to quotes with
 * the same coverage type.
 *
 *   value = 'all' | 'no_excess' | 'with_excess'
 *   onChange(value, { intent: 'instant' })
 *
 * Today RESULTS_CH only carries two distinct values (with / no excess),
 * so a 3-state select is enough. Affects only Market endpoints — Module
 * 1 (Revenue/Fleet/Forecast/Performance) ignores the param.
 */
export default function InsuranceSlicer({ value, onChange }) {
	return (
		<TextField select size="small" label="Insurance"
		           value={value || 'all'}
		           onChange={(e) => onChange(e.target.value, { intent: 'instant' })}
		           sx={{ minWidth: 160 }}>
			<MenuItem value="all">All</MenuItem>
			<MenuItem value="no_excess">No excess</MenuItem>
			<MenuItem value="with_excess">With excess</MenuItem>
		</TextField>
	)
}
